/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from 'axios';
import { call, delay, put, takeLatest } from 'redux-saga/effects';

import api from '../../api/api';
import { errorHandling } from '../../api/errorHandling';
import * as commonSagas from '../_common/commonSagas';
import { apiVersion } from '../apiVersion';
import * as cardtimesSlice from './cardtimesSlice';
import { CardtimePicture } from './cardtimesSlice';

function* getCardtimePicturesSaga(props: {
 type: string;
 payload: number | string;
}) {
 try {
  const version = apiVersion['cards/cardtimes'].getCardtimePictures;
  const response: AxiosResponse<CardtimePicture[]> = yield call(
   api.get,
   `/Cards/v${version}/cardtimes/${props.payload}/pictures`,
  );

  yield put(cardtimesSlice.getCardtimePicturesSuccess(response.data));
  yield delay(0);
  yield put(cardtimesSlice.getCardtimePicturesFinish());
 } catch (error: unknown) {
  yield* errorHandling(error, cardtimesSlice.getCardtimePicturesFailure);
 }
}

export default function* watchCardtimesSaga() {
 yield takeLatest(cardtimesSlice.getTableStart.type, commonSagas.getTable);
 yield takeLatest(cardtimesSlice.getItemStart.type, commonSagas.getItem);
 yield takeLatest(cardtimesSlice.createItemStart.type, commonSagas.createItem);
 yield takeLatest(cardtimesSlice.updateItemStart.type, commonSagas.updateItem);
 yield takeLatest(cardtimesSlice.deleteItemsStart.type, commonSagas.deleteItems);
 yield takeLatest(cardtimesSlice.deleteItemStart.type, commonSagas.deleteItem);
 yield takeLatest(
  cardtimesSlice.getTableStructureStart.type,
  commonSagas.getTableStructure,
 );
 yield takeLatest(
  cardtimesSlice.getItemDocumentsStart.type,
  commonSagas.getItemDocuments,
 );
 yield takeLatest(
  cardtimesSlice.uploadItemDocumentsStart.type,
  commonSagas.uploadItemDocuments,
 );
 yield takeLatest(
  cardtimesSlice.deleteItemDocumentStart.type,
  commonSagas.deleteItemDocument,
 );
 yield takeLatest(
  cardtimesSlice.getTableExcelStart.type,
  commonSagas.getTableExcel,
 );
 yield takeLatest(
  cardtimesSlice.getCardtimePicturesStart.type,
  getCardtimePicturesSaga,
 );
}
